import React from "react";
import About from "./About";
import Mission from './Mission'
import Different from "./Different";
export default function AboutApp(){
    return(
        <>
        <About/>
        <Mission/>
        <Different/>
        </>
    )
}